export const errorless = (p: Promise<any>) => p.catch((err) => null);
